module.exports = __webpack_public_path__ + "fonts/Proxima-Nova-Bold.72b6f2c9.otf";